import React, { useEffect, useState } from 'react';
import UploadFileCard from "../components/UploadFileCard";
import api from '../api/api';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  TextField,
  
  Snackbar,
  Alert,
  Chip,
  Divider,
} from '@mui/material';

import { Grid } from '@mui/material';


export default function EmployerPanel() {
  const [tasks, setTasks] = useState([]);
  const [applications, setApplications] = useState([]);
  const [newTask, setNewTask] = useState({ title: '', description: '' });
  const [alert, setAlert] = useState({ open: false, message: '', severity: 'info' });

  const token = localStorage.getItem('token');

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    try {
      const [tasksRes, appsRes] = await Promise.all([
        api.get('/tasks/my-tasks', { headers: { Authorization: `Bearer ${token}` } }),
        api.get('/applications/received', { headers: { Authorization: `Bearer ${token}` } }),
      ]);
      setTasks(tasksRes.data);
      setApplications(appsRes.data);
    } catch (err) {
      console.error('Error cargando datos:', err);
      showAlert('Error al obtener los datos del servidor', 'error');
    }
  };

  const showAlert = (message, severity = 'info') => {
    setAlert({ open: true, message, severity });
    setTimeout(() => setAlert({ ...alert, open: false }), 3000);
  };

  const handleCreateTask = async (e) => {
    e.preventDefault();
    if (!newTask.title.trim() || !newTask.description.trim()) {
      return showAlert('Completá todos los campos antes de crear la tarea', 'warning');
    }

    try {
      await api.post('/tasks', newTask, { headers: { Authorization: `Bearer ${token}` } });
      setNewTask({ title: '', description: '' });
      fetchData();
      showAlert('Tarea creada exitosamente', 'success');
    } catch (err) {
      showAlert('Error al crear la tarea', 'error');
    }
  };

  const handleDeleteTask = async (id) => {
    try {
      await api.delete(`/tasks/${id}`, { headers: { Authorization: `Bearer ${token}` } });
      fetchData();
      showAlert('Tarea eliminada correctamente', 'success');
    } catch (err) {
      showAlert('Error al eliminar la tarea', 'error');
    }
  };

  const handleUpdateStatus = async (id, status) => {
    try {
      await api.put(
        `/applications/${id}`,
        { status },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      fetchData();
      showAlert(`Postulación ${status === 'aceptada' ? 'aceptada' : 'rechazada'}`, 'success');
    } catch (err) {
      showAlert('Error al actualizar el estado', 'error');
    }
  };

  return (
    <Box sx={{ padding: '40px', marginTop: '40px', backgroundColor: '#F9FAFB', minHeight: '100vh' }}>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 'bold', color: '#00796B' }}>
        Panel del Empleador
      </Typography>

      {/* 🔹 Crear nueva tarea */}
      <Card sx={{ mb: 4, borderRadius: 3, boxShadow: 2 }}>
        <CardContent>
          <Typography variant="h6" sx={{ mb: 2, color: '#004D40' }}>
            Crear nueva tarea
          </Typography>
          <form onSubmit={handleCreateTask}>
            <Grid container spacing={2}>
              <Grid xs={12} md={6}>
                <TextField
                  label="Título"
                  name="title"
                  fullWidth
                  value={newTask.title}
                  onChange={(e) => setNewTask({ ...newTask, title: e.target.value })}
                />
              </Grid>
              <Grid xs={12} md={5}>
                <TextField
                  label="Descripción"
                  name="description"
                  fullWidth
                  value={newTask.description}
                  onChange={(e) => setNewTask({ ...newTask, description: e.target.value })}
                />
              </Grid>
              <Grid xs={12} md={1}>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  fullWidth
                  sx={{ height: '100%', backgroundColor: '#00796B', borderRadius: 2 }}
                >
                  +
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>

      {/* 🔹 Tareas creadas */}
      <Typography variant="h6" sx={{ mb: 2, color: '#004D40' }}>
        Tus tareas publicadas
      </Typography>
      <Grid container spacing={2}>
        {tasks.map((task) => (
          <Grid xs={12} md={6} lg={4} key={task.id}>
            <Card sx={{ borderRadius: 3, boxShadow: 1 }}>
              <CardContent>
                <Typography variant="h6">{task.title}</Typography>
                <Typography variant="body2" sx={{ color: 'gray', mb: 2 }}>
                  {task.description}
                </Typography>
                <Button
                  variant="outlined"
                  color="error"
                  onClick={() => handleDeleteTask(task.id)}
                >
                  Eliminar
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Divider sx={{ my: 4 }} />

      {/* 🔹 Postulaciones recibidas */}
      <Typography variant="h6" sx={{ mb: 2, color: '#004D40' }}>
        Postulaciones recibidas
      </Typography>

      {applications.length === 0 ? (
        <Typography variant="body1" sx={{ color: 'gray' }}>
          No hay postulaciones aún.
        </Typography>
      ) : (
        <Grid container spacing={2}>
          {applications.map((app) => (
            <Grid xs={12} md={6} lg={4} key={app.application_id}>
              <Card sx={{ borderRadius: 3, boxShadow: 1, borderLeft: '4px solid #00796B' }}>
                <CardContent>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#00796B' }}>
                    {app.worker_name}
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    {app.worker_email}
                  </Typography>
                  <Typography variant="subtitle2" sx={{ color: '#004D40' }}>
                    {app.task_title}
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 2, color: 'gray' }}>
                    {app.task_description}
                  </Typography>

                  <Chip
                    label={app.status}
                    color={
                      app.status === 'aceptada'
                        ? 'success'
                        : app.status === 'rechazada'
                        ? 'error'
                        : 'warning'
                    }
                    sx={{ mb: 1 }}
                  />

                  <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                    <Button
                      variant="contained"
                      color="success"
                      onClick={() => handleUpdateStatus(app.application_id, 'aceptada')}
                    >
                      Aceptar
                    </Button>
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={() => handleUpdateStatus(app.application_id, 'rechazada')}
                    >
                      Rechazar
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      {/* Snackbar de feedback */}
      <Snackbar open={alert.open} autoHideDuration={3000}>
        <Alert severity={alert.severity} sx={{ width: '100%' }}>
          {alert.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
